import { render, staticRenderFns } from "./HeaderInquiries.vue?vue&type=template&id=1d7e6f0f&scoped=true&"
import script from "./HeaderInquiries.vue?vue&type=script&lang=js&"
export * from "./HeaderInquiries.vue?vue&type=script&lang=js&"
import style0 from "./HeaderInquiries.vue?vue&type=style&index=0&id=1d7e6f0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7e6f0f",
  null
  
)

export default component.exports